import WaitingPartyModal from './waiting-party-modal';

export default WaitingPartyModal;
